import Component from "flarum/common/Component";

export default class Collapsible extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.collapsed = true;
  }

  onbeforeupdate(vnode, old) {
    super.onbeforeupdate(vnode, old);

    if (vnode.attrs.isOpen !== old.attrs.isOpen) {
      this.collapsed = !vnode.attrs.isOpen;
    }
  }

  view(vnode) {
    const { subs, className, onToggle } = this.attrs;
    const hasSubs = subs?.length > 0;

    return (
      <div
        className={`Collapsible ${className} ${this.collapsed ? "" : "active"}`}
      >
        <div className="Collapsible-content">
          {vnode.children[0]}

          {hasSubs && (
            <div
              className="Collapsible-headerToggle"
              onclick={(e) => {
                e.stopPropagation();
                this.toggle();

                if (onToggle) onToggle();
              }}
            >
              <div className="Collapsible-headerToggleIcon">
                <i
                  className={`fas fa-chevron-${this.collapsed ? "down" : "up"}`}
                />
              </div>
            </div>
          )}
        </div>

        {!this.collapsed && hasSubs && (
          <div
            className={`Collapsible-openedContent ${this.collapsed ? "" : "open"}`}
          >
            {subs.map((sub) => sub)}
          </div>
        )}
      </div>
    );
  }

  toggle() {
    this.collapsed = !this.collapsed;
  }
}
